/**
 * @generated SignedSource<<1444f253e088d2650e13ccb448d9bf1b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StreamAccessType = "full" | "partial" | "shared";
export type MergeStream_SummaryQuery$variables = {
  destinationStreamId: string;
  sourceStreamId: string;
};
export type MergeStream_SummaryQuery$data = {
  readonly destinationStream: {
    readonly claimedEvents: ReadonlyArray<{
      readonly id: string;
    }>;
    readonly displayName: string;
    readonly feedbackList: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly hasAnyAutomationActive: boolean;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly isExternal: boolean;
      };
    }>;
    readonly objectivesTabEnabled: boolean | null;
    readonly tabs: ReadonlyArray<{
      readonly icon: string | null;
      readonly id: string;
      readonly isEmbedded: boolean;
      readonly order: number;
      readonly otherStreamId: string | null;
      readonly title: string;
      readonly url: string | null;
    }>;
    readonly template: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"MergeStream_StreamIntegration">;
  } | null;
  readonly sourceStream: {
    readonly claimedEvents: ReadonlyArray<{
      readonly title: string;
    }>;
    readonly displayName: string;
    readonly feedbackList: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
        };
      }>;
    };
    readonly hasAnyAutomationActive: boolean;
    readonly notesCount: number;
    readonly notestreamusers: ReadonlyArray<{
      readonly accessType: StreamAccessType;
      readonly user: {
        readonly fullName: string;
        readonly id: string;
        readonly isExternal: boolean;
      };
    }>;
    readonly objectivesTabEnabled: boolean | null;
    readonly tabs: ReadonlyArray<{
      readonly icon: string | null;
      readonly id: string;
      readonly isEmbedded: boolean;
      readonly order: number;
      readonly otherStreamId: string | null;
      readonly title: string;
      readonly url: string | null;
    }>;
    readonly template: {
      readonly id: string;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"MergeStream_StreamIntegration">;
  } | null;
  readonly viewer: {
    readonly user: {
      readonly id: string;
    };
  };
};
export type MergeStream_SummaryQuery = {
  response: MergeStream_SummaryQuery$data;
  variables: MergeStream_SummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "destinationStreamId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sourceStreamId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = [
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "destinationStreamId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAnyAutomationActive",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "objectivesTabEnabled",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Event",
  "kind": "LinkedField",
  "name": "claimedEvents",
  "plural": true,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "onlyMeetingFeedback",
      "value": false
    }
  ],
  "concreteType": "NonNullFeedbackConnection",
  "kind": "LinkedField",
  "name": "feedbackList",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NonNullFeedbackEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FeedbackNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "feedbackList(onlyMeetingFeedback:false)"
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accessType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "User",
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isExternal",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteTemplateNode",
  "kind": "LinkedField",
  "name": "template",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamTabNode",
  "kind": "LinkedField",
  "name": "tabs",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherStreamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmbedded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "integrationProvider",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "AsanaStreamNode",
  "kind": "LinkedField",
  "name": "asanaStream",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v19 = {
  "kind": "InlineDataFragmentSpread",
  "name": "MergeStream_StreamIntegration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "StreamActionItemIntegrationNode",
      "kind": "LinkedField",
      "name": "actionItemIntegration",
      "plural": false,
      "selections": [
        (v17/*: any*/)
      ],
      "storageKey": null
    },
    (v18/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v20 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "sourceStreamId"
  }
],
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notesCount",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamUser",
  "kind": "LinkedField",
  "name": "notestreamusers",
  "plural": true,
  "selections": [
    (v11/*: any*/),
    (v12/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "StreamActionItemIntegrationNode",
  "kind": "LinkedField",
  "name": "actionItemIntegration",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeStream_SummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "destinationStream",
        "args": (v5/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "sourceStream",
        "args": (v20/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v21/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "claimedEvents",
            "plural": true,
            "selections": [
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v19/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "MergeStream_SummaryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "destinationStream",
        "args": (v5/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v22/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v23/*: any*/),
          (v18/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "sourceStream",
        "args": (v20/*: any*/),
        "concreteType": "NoteStream",
        "kind": "LinkedField",
        "name": "noteStream",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v21/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "claimedEvents",
            "plural": true,
            "selections": [
              (v15/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v10/*: any*/),
          (v22/*: any*/),
          (v14/*: any*/),
          (v16/*: any*/),
          (v23/*: any*/),
          (v18/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b2bafcce9af850be564413322bdc1f7",
    "id": null,
    "metadata": {},
    "name": "MergeStream_SummaryQuery",
    "operationKind": "query",
    "text": "query MergeStream_SummaryQuery(\n  $sourceStreamId: ID!\n  $destinationStreamId: ID!\n) {\n  viewer {\n    user {\n      id\n    }\n    id\n  }\n  destinationStream: noteStream(id: $destinationStreamId) {\n    displayName\n    hasAnyAutomationActive\n    objectivesTabEnabled\n    claimedEvents {\n      id\n    }\n    feedbackList(onlyMeetingFeedback: false) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    notestreamusers {\n      accessType\n      user {\n        id\n        fullName\n        isExternal\n      }\n      id\n    }\n    template {\n      id\n    }\n    tabs {\n      id\n      otherStreamId\n      icon\n      title\n      order\n      isEmbedded\n      url\n    }\n    ...MergeStream_StreamIntegration\n    id\n  }\n  sourceStream: noteStream(id: $sourceStreamId) {\n    displayName\n    hasAnyAutomationActive\n    notesCount\n    objectivesTabEnabled\n    claimedEvents {\n      title\n      id\n    }\n    feedbackList(onlyMeetingFeedback: false) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    notestreamusers {\n      accessType\n      user {\n        id\n        fullName\n        isExternal\n      }\n      id\n    }\n    template {\n      id\n    }\n    tabs {\n      id\n      otherStreamId\n      icon\n      title\n      order\n      isEmbedded\n      url\n    }\n    ...MergeStream_StreamIntegration\n    id\n  }\n}\n\nfragment MergeStream_StreamIntegration on NoteStream {\n  actionItemIntegration {\n    integrationProvider\n    id\n  }\n  asanaStream {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba19975de2d1b982393d7753aa4ff372";

export default node;
